export const people = [
  {
    name: 'Dr Mitchell Anderson',
    role: 'Chief Executive Officer',
    imageUrl: '/website/staff/Ex-173-c.jpg',
    xUrl: '#',
    linkedinUrl: '#',
  },
  {
    name: 'Dr Tom Logan',
    role: 'Chief Technical Officer',
    imageUrl: '/website/staff/TomLogan.jpg',
    xUrl: '#',
    linkedinUrl: '#',
  },
  {
    name: 'Dr Paula Blackett',
    role: 'Research Director',
    imageUrl: '/website/staff/Paula-Cropped.jpg',
    xUrl: '#',
    linkedinUrl: '#',
  },
  {
    name: 'Hamish Campbell',
    role: 'Head of Engineering',
    imageUrl: '/website/staff/Hamish.jpg',
    xUrl: '#',
    linkedinUrl: '#',
  },
  {
    name: 'Dr Ria Chapman',
    role: 'Product Manager',
    imageUrl: '/website/staff/Ria C.jpg',
    xUrl: '#',
    linkedinUrl: '#',
  },
  {
    name: 'Dr Andrew Allison',
    role: 'Technical Director',
    imageUrl: '/website/staff/Andrew.jpg',
    xUrl: '#',
    linkedinUrl: '#',
  },
  {
    name: 'Gerard Logan',
    role: 'Business Development',
    imageUrl: '/website/staff/Gerard.jpg',
    xUrl: '#',
    linkedinUrl: '#',
  },
  {
    name: 'Dr Sarah Harrison',
    role: 'Researcher',
    imageUrl: '/website/staff/Sarah Harrison.jpg',
    xUrl: '#',
    linkedinUrl: '#',
  },
  {
    name: `Debbie O'Byrne`,
    role: 'Customer Success Manager',
    imageUrl: '/website/staff/debbie_cropped.jpg',
    xUrl: '#',
    linkedinUrl: '#',
  },
  {
    name: 'Logan Brunner',
    role: 'Senior Risk Analyst',
    imageUrl: '/website/staff/Logan.jpg',
    xUrl: '#',
    linkedinUrl: '#',
  },
  {
    name: 'Maggie Fellowes',
    role: 'Senior Adaptation Advisor',
    imageUrl: '/website/staff/Maggie.jpg',
    xUrl: '#',
    linkedinUrl: '#',
  },

  {
    name: 'Matt Edwards',
    role: 'Risk Analyst',
    imageUrl: '/website/staff/Matt.jpg',
    xUrl: '#',
    linkedinUrl: '#',
  },
  {
    name: 'Callum Snell',
    role: 'Risk Analyst',
    imageUrl: '/website/staff/Callum.jpg',
    xUrl: '#',
    linkedinUrl: '#',
  },
  {
    name: 'Zak Barham',
    role: 'Risk Analyst',
    imageUrl: '/website/staff/Zak.jpg',
    xUrl: '#',
    linkedinUrl: '#',
  },
  {
    name: 'Sam Archie',
    role: 'Data Engineer',
    imageUrl: '/website/staff/Sam.jpg',
    xUrl: '#',
    linkedinUrl: '#',
  },
  {
    name: 'Chris Schipani',
    role: 'Full Stack Developer',
    imageUrl: '/website/staff/Christian.jpg',
    xUrl: '#',
    linkedinUrl: '#',
  },
  {
    name: 'Rogerio Menezes',
    role: 'Full Stack Developer',
    imageUrl: '/website/staff/Rogerio.jpg',
    xUrl: '#',
    linkedinUrl: '#',
  },
  {
    name: 'Rupert Paterson',
    role: 'Full Stack Developer',
    imageUrl: '/website/staff/Rupert.jpg',
    xUrl: '#',
    linkedinUrl: '#',
  },
  {
    name: 'Kevin Pluck',
    role: 'Full Stack Developer',
    imageUrl: '/website/staff/Kevin.jpg',
    xUrl: '#',
    linkedinUrl: '#',
  },

  {
    name: 'Emma Harris',
    role: 'UX Designer',
    imageUrl: '/website/staff/Emma-cropped.png',
    xUrl: '#',
    linkedinUrl: '#',
  },
  {
    name: 'Sarah Pauli',
    role: 'Communications',
    imageUrl: '/website/staff/Sarah Pauli.jpg',
    xUrl: '#',
    linkedinUrl: '#',
  },
  {
    name: 'Fiona Fraser',
    role: 'Finance Administrator',
    imageUrl: '/website/staff/Fiona.jpg',
    xUrl: '#',
    linkedinUrl: '#',
  },
  {
    name: 'Chantelle Chalmers',
    role: 'Operations Support',
    imageUrl: '/website/staff/Chantelle.jpg',
    xUrl: '#',
    linkedinUrl: '#',
  },
  {
    name: 'Baptiste Lett',
    role: 'Executive Assistant',
    imageUrl: '/website/staff/baptiste_cropped.jpg',
    xUrl: '#',
    linkedinUrl: '#',
  },
]

const TeamComponent = () => {
  return (
    <div className="py-10 bg-white">
      <div className="flex items-center justify-center w-full h-full">
        <h1 className="z-10 text-4xl font-light text-center lg:text-h1Light text-text-primary text-balance">
          The Urban Intelligence Team
        </h1>
      </div>
      <div className="max-w-6xl px-6 mx-auto text-center lg:px-8">
        <ul
          role="list"
          className="grid max-w-2xl grid-cols-1 mx-auto mt-20 gap-x-8 gap-y-16 sm:grid-cols-3 lg:mx-0 lg:max-w-none lg:grid-cols-4"
        >
          {people.map((person) => (
            <li key={person.name} className="list-none">
              <div className="mx-auto overflow-hidden bg-gray-100 rounded-full size-56">
                <img
                  src={person.imageUrl}
                  alt={person.name}
                  className="object-cover object-center w-full h-full"
                />
              </div>

              <h3 className="mt-6 font-semibold tracking-tight text-gray-900 text-base/7">
                {person.name}
              </h3>

              <p className="text-gray-600 text-sm/6">{person.role}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
export default TeamComponent
